import { render, staticRenderFns } from "./proposedRodeDetail.vue?vue&type=template&id=6d9a09b6&"
import script from "./proposedRodeDetail.vue?vue&type=script&lang=js&"
export * from "./proposedRodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./proposedRodeDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "proposedRodeDetail.vue"
export default component.exports